import(/* webpackMode: "eager", webpackExports: ["StoreProfilePageBase"] */ "/app/src/app/(store-profile)/[slug]/components/StoreProfilePageBase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTextContentContextProvider"] */ "/app/src/context/pageTextContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorPage"] */ "/app/src/layout/ErrorPage.tsx");
